import { Link } from 'react-router-dom';
import { postListFetcher } from '@/shared/api/list';
import type { WeekSchedule } from '@/shared/lib/schedule';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import { ScheduleCell } from '@/shared/ui/list/ScheduleCell';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';

interface Agent extends ListRow {
  id: number;
  name?: string;
  contact_person?: string;
  contact_person_phone?: string;
  email?: string;
  status_id?: number;
  schedule?: WeekSchedule;
  address?: string;
}

const STATUS_NAMES: Record<number, string> = {
  1: 'Неактивен',
  2: 'Активен',
  3: 'Отмодерирован',
  4: 'Заблокирован',
  5: 'Верифицирован',
  6: 'Деактивирован',
};

const config: ListPageConfig<Agent> = {
  queryKey: 'insurance-agents',
  title: 'Агенты',
  errorText: 'Ошибка загрузки агентов',
  fetchList: postListFetcher('/service/agents/list/'),
  rows: ['agents'],
  columns: [
    { header: '№', render: (_, { number }) => number },
    {
      header: 'ID СТО',
      render: (agent) => <Link to={`/users/user/${agent.id}`}>{agent.id}</Link>,
    },
    {
      header: 'Название СТО',
      render: (agent) => <Link to={`/users/edit/${agent.id}`}>{agent.name}</Link>,
    },
    { header: 'Контактное лицо', render: (agent) => agent.contact_person },
    { header: 'Телефон', render: (agent) => agent.contact_person_phone },
    { header: 'E-mail', render: (agent) => agent.email },
    { header: 'Статус СТО', render: (agent) => STATUS_NAMES[Number(agent.status_id)] },
    { header: 'График работы', render: (agent) => <ScheduleCell schedule={agent.schedule} /> },
    { header: 'Адрес', render: (agent) => agent.address },
  ],
};

export const AgentsPage = () => <GenericListPage config={config} />;
